
const m = window.require("discourse/components/bulk-actions/change-category");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
